export const MIN_INTERVAL = 60000
export const FIVE_MIN_INTERVAL = 300000
export const TEN_MIN_INTERVAL = 600000
export const THIRTY_MIN_INTERVAL = 1800000
export const HOUR_INTERVAL = 3600000
export const TWO_HOUR_INTERVAL = 7200000
export const THREE_HOUR_INTERVAL = 10800000
export const SIX_HOUR_INTERVAL = 21600000
export const TWELVE_HOUR_INTERVAL = 43200000
export const DAY_INTERVAL = 86400000
export const TWO_DAY_INTERVAL = 172800000 // 2일
export const FOUR_DAY_INTERVAL = 345600000 // 4일
export const EIGHT_DAY_INTERVAL = 691200000 // 8일
export const SIXTEEN_DAY_INTERVAL = 1382400000 // 16일

const intervals = {
  MIN_INTERVAL,
  FIVE_MIN_INTERVAL,
  TEN_MIN_INTERVAL,
  THIRTY_MIN_INTERVAL,
  HOUR_INTERVAL,
  TWO_HOUR_INTERVAL,
  THREE_HOUR_INTERVAL,
  SIX_HOUR_INTERVAL,
  TWELVE_HOUR_INTERVAL,
  DAY_INTERVAL,
  TWO_DAY_INTERVAL,
  FOUR_DAY_INTERVAL,
  EIGHT_DAY_INTERVAL,
  SIXTEEN_DAY_INTERVAL,
}

export const timeIntervalList = Object.values(intervals)

export const timelineHeight = 234
export const activityBoxStartHeight = 77
export const activityIntervalDistance = 8
export const activityBoxHeight = 35
export const sessionBoxStartHeight = 35
export const deviceStartHeight = 30
export const deviceHeight = 68
export const deviceBoxHeight = 32

export const ACTIVITY_BOX_GUARANTEED_VISIBILITY_HEIGHT = 5
export const ACTIVITY_BOX_GUARANTEED_VISIBILITY_FROM_TOP = 46
export const ACTIVITY_TIMELINE_AXIS_X_ADJUST = 35
